import styled from "@emotion/styled";
import { Button } from "react-aria-components";

/**
 * Inline-text-styled button used by the About modal's clickable date and time
 * spans. Renders as inline text with a subtle dotted underline to signal "this
 * looks like text but it's editable" — the same affordance the mocks specify
 * for the editable created date / time tokens.
 */
export const InlineEditableTrigger = styled(Button)`
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  font: inherit;
  color: inherit;
  cursor: pointer;
  text-decoration: underline dotted;
  text-underline-offset: 3px;
  text-decoration-color: ${({ theme }) => theme.colors.text.tertiary};
  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.border.emphasis};
    outline-offset: 2px;
    border-radius: 2px;
  }
`;
